import { renderPermissionCheckbox } from '_/views/group-permissions-shared/checkbox-helpers'

export const groupColumns = (handleSetValue, formState) => [
  {
    field: 'permissionName',
    headerName: 'Permissão',
    minWidth: '100%',
    maxWidth: '100%',
    editable: false,
  },
  {
    field: 'read',
    headerName: 'Ver',
    editable: false,
    renderCell: ({ row, value }) =>
      renderPermissionCheckbox({
        row,
        value,
        field: 'read',
        allowedField: 'allowedRead',
        formState,
        handleSetValue,
      }),
  },
  {
    field: 'create',
    headerName: 'Gerenciar',
    editable: false,
    renderCell: ({ row, value }) =>
      renderPermissionCheckbox({
        row,
        value,
        field: 'create',
        allowedField: 'allowedCreate',
        formState,
        handleSetValue,
      }),
  },
  {
    field: 'delete',
    headerName: 'Excluir',
    editable: false,
    renderCell: ({ row, value }) =>
      renderPermissionCheckbox({
        row,
        value,
        field: 'delete',
        allowedField: 'allowedDelete',
        formState,
        handleSetValue,
      }),
  },
]

export const TABLE_SX = {
  fontSize: '1.4rem',
  width: '100%',

  '& .MuiDataGrid-virtualScrollerRenderZone': {
    width: '100%',
  },

  '& .MuiDataGrid-columnHeadersInner': {
    width: '100%',

    '> div': {
      width: '100%',
    },
  },

  '& .MuiDataGrid-columnHeaders': {
    width: '100%',
  },

  '& .MuiDataGrid-columnHeader': {
    width: '100%',
  },

  '& .MuiDataGrid-row': {
    width: '100%',
  },

  '& .MuiDataGrid-cell': {
    width: '100%',
  },

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
